import getFeature from '../features';

const isFileOverlarge = (
  file: { size: number },
  maxSizeMB: number = getFeature('attachment_size_limit'),
) => file.size > maxSizeMB * 1000 * 1000;

export default isFileOverlarge;
